import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { doc, updateDoc, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import {
  FaReceipt, 
  FaSpinner, 
  FaCheckCircle,
  FaHandHoldingUsd,
} from 'react-icons/fa';
import './CashPaiement.css';

const CashPaiement = () => {
  const [isWaiting, setIsWaiting] = useState(true); // Statut de l'attente
  const [setPaymentStatus] = useState('');
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem('userInfo')); // Utilisateur actuel
  const total = parseFloat(localStorage.getItem('total')) || 0; // Récupérer le total depuis le localStorage
  
  useEffect(() => {
    // Créer un nouveau paiement dans la base de données (en_attente)
    const createPayment = async () => {
      try {
        const moyenPaiement = localStorage.getItem('moyen_paiement') || '';
        const clientRef = doc(db, 'clients', userInfo.id);
        await updateDoc(clientRef, {
          paiement: {
            status: 'en_attente',
            moyen_paiement: moyenPaiement
          }
        });
      } catch (error) {
        console.error('Erreur lors de la création du paiement:', error);
      }
    };    
  
    // Suivre le statut du paiement
    const trackPaymentStatus = async () => {
      const clientRef = doc(db, 'clients', userInfo.id);
  
      onSnapshot(clientRef, (docSnapshot) => {
        const clientData = docSnapshot.data();
        const status = clientData?.paiement?.status || '';
  
        if (status === 'payé') {
          setPaymentStatus('Paiement effectué');
          setIsWaiting(false);
  
          // Rediriger vers la page de confirmation après paiement
          setTimeout(() => {
            navigate('/confirmation', { state: { paymentIntent: { status: 'succeeded' } } });
          }, 2000); // Attendre 2 secondes avant de rediriger
        } else if (status === 'en_attente') {
          setPaymentStatus('En attente de paiement...');
        }
      });
    };
  
    createPayment();
    trackPaymentStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.id, navigate]);  

  return (
    <div className="cashpaiement-container">
      {/* Header */}
      <div className="header-section">
        <FaReceipt className="title-icon" />
        <h1>Statut du Paiement</h1>
      </div>

      {/* Main Status Card */}
      <div className="main-card">
        {isWaiting ? (
          <div className="status-content">
            <FaSpinner className="status-icon spinning" />
            <h2>En attente de paiement</h2>
            <p>Merci pour votre commande !</p>
          </div>
        ) : (
          <div className="status-content success">
            <FaCheckCircle className="status-icon" />
            <h2>Paiement effectué</h2>
            <p>Merci pour votre commande !</p>
          </div>
        )}
      </div>

      {/* Order Info */}
      <div className="order-info">
        <div className="order-details">
          <span className="order-label">Commande #{userInfo.idclient}</span>
          {total && (
            <span className="total-amount">{total.toFixed(2)} €</span>
          )}
        </div>
        <div className="instruction">
          <FaHandHoldingUsd className="instruction-icon" />
          <span>Un serveur arrive pour vous encaisser</span>
        </div>
      </div>
    </div>
  );
};

export default CashPaiement;
